import { render } from "./MovementModal.vue?vue&type=template&id=139aa1b6"
import script from "./MovementModal.vue?vue&type=script&lang=js"
export * from "./MovementModal.vue?vue&type=script&lang=js"

import "./MovementModal.vue?vue&type=style&index=0&id=139aa1b6&lang=css"

import exportComponent from "/builds/aksoftware/software/haushaltsbuchfrontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__